import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-input-number-down",
  "use": "icon-input-number-down-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 9\" fill=\"none\" id=\"icon-input-number-down\">\n  <path d=\"M2.03083 3.46965L4.2149 6.0184C4.2501 6.05946 4.29377 6.09242 4.34291 6.11502C4.39205 6.13761 4.4455 6.14931 4.49958 6.14931C4.55367 6.14931 4.60712 6.13761 4.65626 6.11502C4.7054 6.09242 4.74907 6.05946 4.78427 6.0184L6.96833 3.46965C7.17677 3.22637 7.00396 2.85059 6.68365 2.85059H2.3149C1.99458 2.85059 1.82177 3.22637 2.03083 3.46965Z\" fill=\"#E1E2E6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol